/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import { clearLastSelectedBranchId } from '../../shared/localPrefs';
import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { navigateRoot } from '../../shell/navigation/rootNavigation';
import type { NavigationProp, ParamListBase } from '@react-navigation/native';

/** Vuelve al hub post-login (panel dueño) sin sucursal activa. */
export async function returnToPostLoginHubPanel(
  navigation: NavigationProp<ParamListBase>,
): Promise<void> {
  await clearLastSelectedBranchId();
  useSessionStore.getState().setCurrentBranch(undefined, { resetShell: false });
  navigateRoot(navigation, 'PostLoginHub');
}
